import { render, staticRenderFns } from "./PhoneNumberColumn.vue?vue&type=template&id=e4eb0bac&"
import script from "./PhoneNumberColumn.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberColumn.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4eb0bac')) {
      api.createRecord('e4eb0bac', component.options)
    } else {
      api.reload('e4eb0bac', component.options)
    }
    module.hot.accept("./PhoneNumberColumn.vue?vue&type=template&id=e4eb0bac&", function () {
      api.rerender('e4eb0bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/PhoneNumberColumn.vue"
export default component.exports